import { render, staticRenderFns } from "./TabFinancialProtocol.vue?vue&type=template&id=d61e94cc&scoped=true"
import script from "./TabFinancialProtocol.vue?vue&type=script&lang=js"
export * from "./TabFinancialProtocol.vue?vue&type=script&lang=js"
import style0 from "./TabFinancialProtocol.vue?vue&type=style&index=0&id=d61e94cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61e94cc",
  null
  
)

export default component.exports